<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #EEEEEE; padding-top: 4px;" v-if="hasGame">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <span class="topic-type">{{ topicType }}</span>
          <p>{{ topicName }} </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="question-no-show">
        <div v-for="questionNo in questionNoShow" :key="questionNo">
          {{ convertNumberToLangWise(questionNo) }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="count-down-question" v-if="timeCountShow" :style="countDownColor">
        {{ countDown }}s
      </div>
    </div>

    <div class="row">
      <div class="question-image" v-if="question.type === 'image'">
        <img :src="question.src_url" :alt="question.question_value">
      </div>
    </div>

    <div class="row">
      <div class="question" v-if="question.question_value">
        <div class="title">{{ question.question_value }}</div>
        <div class="report" @click="reportQuestion">
          {{ $t('REPORT') }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="questions-options">
        <div class="question-option"
             v-for="question_option in question.options" :key="question_option.id"
             @click="setQuestionOption(question_option.id)"
             :style="[question_option.id === selectQuestionOption && submitAnswerClass
             ? submitAnswerClass : '']"
        >
          {{ question_option.value }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="d-flex justify-content-between fixed-bottom answer-btn-background" v-if="selectQuestionOption">
<!--        <argon-button fullWidth color="danger"-->
<!--                      variant="gradient"-->
<!--                      class="my-4 mb-1 me-2"-->
<!--                      @click="tryAgain"-->
<!--                      style="background: #FFFFFF; color: #F42F75; font-weight: bold;"-->
<!--                      v-if="! isCorrect">-->
<!--          <span>-->
<!--            <img src="@/assets/img/coin.png" alt="coin">-->
<!--          </span>-->
<!--          {{ $t('USE_COIN') }}-->
<!--        </argon-button>-->
        <argon-button fullWidth color="danger"
                      variant="gradient"
                      class="my-4 mb-1 me-2"
                      @click="nextQuestionSet"
                      style="background: #8435E8; color: #FFFFFF; font-weight: bold;" v-if="! questionFinish">
          {{ $t('NEXT') }}
        </argon-button>
        <argon-button fullWidth color="danger"
                      variant="gradient"
                      class="my-4 mb-1 me-2"
                      @click="showResult"
                      style="background: #8435E8; color: #FFFFFF; font-weight: bold;" v-if="questionFinish">
          {{ $t('SEE_RESULT') }}
        </argon-button>
      </div>
      <div class="text-danger" v-if="errorMsg">{{ errorMsg }}</div>
    </div>
    <ResultModal :modal-show="resultModalOpen" :result-played="resultPlayed" v-if="resultModalOpen"/>
    <ReportModal :modal-show="reportModalOpen" :question-id="question.question_id" v-if="reportModalOpen"/>
    <FriendListModal :modal-show="friendModalOpen" v-if="friendModalOpen"/>
  </div>
  <div class="d-flex justify-content-center align-items-center mt-2" v-else>
    No Question Found.
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import ArgonButton from "@/components/ArgonButton";
import ResultModal from "@/views/components/ResultModal";
import ReportModal from "@/views/components/ReportModal";
import FriendListModal from "@/views/components/FriendListModal";

export default {
  name: "GamePlay",
  components: {
    Loader,
    ArgonButton,
    ResultModal,
    ReportModal,
    FriendListModal,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      topicType: this.$route.query.topic,
      topicName: this.$route.query.category_name,
      game: [],
      questionNoShow: [],
      question: [],
      startQuestionNo: 0,
      questionsLeft: 0,
      countDown: 0,
      timeCountShow: true,
      selectQuestionOption: '',
      countDownColor: '',
      answerData: [],
      submitAnswerClass: '',
      isCorrect: true,
      questionFinish: false,
      errorMsg: '',
      resultModalOpen: false,
      reportModalOpen: false,
      resultPlayed: [],
      hasGame: false,
      friendModalOpen: false,
    }
  },
  created() {
    this.getGame(this.$route.params.id);
    this.emitter.on('result-modal-close-event', (evt) => {
      this.resultModalOpen = evt.eventContent;
      this.$router.back();
    });
    this.emitter.on('next-topic-run', (evt) => {
      this.resultModalOpen = evt.eventContent;
      this.$router.push({
        path: '/topic-details', query: {
          topic_id: this.resultPlayed.next_topic_id,
          topic: this.resultPlayed.next_topic_category,
          category_name: this.resultPlayed.next_topic_title
        }});
    });
    this.emitter.on('play-again', (evt) => {
      this.resultModalOpen = evt.eventContent;
      this.questionNoShow = [];
      this.resetCountDownAndOption()
      this.getGame(this.$route.params.id);
    });
    this.emitter.on('report-modal-close-event', (evt) => {
      this.reportModalOpen = evt.eventContent;
    });
    this.emitter.on('challenge-friend-modal-open', (evt) => {
      this.friendModalOpen = evt.eventContent;
      this.reportModalOpen = ! evt.eventContent;

    });
    this.emitter.on('friend-list-modal-close-event', (evt) => {
      this.friendModalOpen = evt.eventContent;
      this.reportModalOpen = ! evt.eventContent;

    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },

    getGame(topic_id) {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/gameplay/start', {topic_id: topic_id}, this.config)
          .then( response => {
            this.loaderActive = false;
            if(response.success) {
              this.hasGame = true;
              this.game = response.data;
              this.question = this.game.question;
              this.startQuestionNo = this.question.question_no;
              this.questionsLeft = this.question.questions_left;
              this.noShow();
              this.countDown = this.question.timer;
              this.countDownTimer();
            }

          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

    noShow() {
      let questionNoCount = 1;
      for (let no = 0; no <= this.questionsLeft; no++, questionNoCount++) {
        if (questionNoCount === 6) {
          return this.questionNoShow;
        }
        this.questionNoShow.push(this.startQuestionNo);
        this.startQuestionNo++;
      }

      return this.questionNoShow;
    },

    countDownTimer () {
      if (! this.countDown) {
        this.timeCountShow = false;
        return;
      }
      if (String(this.selectQuestionOption).length !== 0) {
        return;
      }
      if (this.countDown > 0) {
        if (this.countDown < 11) {
          this.countDownColor = { color: '#F42F75' }
        }
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer();
        }, 1000)
      }
    },

    setQuestionOption(select_option) {
      if (String(this.selectQuestionOption).length === 0) {
        this.selectQuestionOption = select_option;
        let data = {
          answer_id: this.selectQuestionOption,
          game_id: this.game.game_id,
          question_id: this.question.question_id,
          remaining_time: this.countDown
        }
        sendRequest('post', 'v2.0/gameplay/submit', data, this.config)
            .then( response => {
              this.loaderActive = false;
              this.answerData = response.data;
              this.submitAnswerClass = {
                'border': '1px solid #8424A5',
              }
              this.questionFinish = this.answerData.question_finished;
              this.isCorrect = this.answerData.is_correct;
              if (this.isCorrect) {
                this.submitAnswerClass = {
                  'background': '#3BB461',
                  'color': '#FFFFFF'
                }
              }
              if (this.questionFinish) {
                this.resultPlayed = this.answerData;
              }
            })
            .catch(() => {
              this.loaderActive = false;
            });
      }
    },

    nextQuestionSet() {
      this.selectQuestionOption = '';
      this.question = this.answerData.question;
      this.startQuestionNo = this.question.question_no;
      this.questionsLeft = this.question.questions_left;
      this.questionNoShow = [];
      if (! this.questionsLeft) {
        this.questionNoShow = [];
        this.questionNoShow.push(this.startQuestionNo);
      }
      this.resetCountDownAndOption();
    },

    resetCountDownAndOption() {
      this.submitAnswerClass = '';
      this.isCorrect = true;
      if (this.questionsLeft !== 0) {
        this.noShow();
      }

      this.countDown = this.question.timer;
      this.countDownTimer();
    },

    tryAgain() {
      this.errorMsg = '';
      let data = {
        game_id: this.game.game_id,
        question_id: this.question.question_id,
        using: "coins"
      }
      sendRequest('post', 'v2.0/gameplay/try-again', data, this.config)
          .then( response => {
            this.loaderActive = false;
            if (response.data.success) {
              this.resetCountDownAndOption();
            } else {
              this.errorMsg = response.data.message;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

    showResult() {
      this.resultModalOpen = true;
    },

    reportQuestion() {
      this.reportModalOpen = true;
    }
  },
}
</script>

<style scoped>

</style>
